import { useApiClient } from '../composables/useApiClient.ts';

export default {
    index(query: string = '') {
        return useApiClient().get(`bookkeepings/ksef/purchase-invoices${query}`);
    },
    indexArchived(query: string = '') {
        return useApiClient().get(`bookkeepings/ksef/archived-purchase-invoices${query}`);
    },
    setApprovalStatus(invoiceIds: number[], status: string) {
        return useApiClient().post('bookkeepings/ksef/purchase-invoices/bulk-set-status', {
            invoice_ids: invoiceIds,
            approval_status: status,
        });
    },
    returnToVerification(invoiceIds: number[], comment: string | null = null, itemComments: Record<number, string> = {}) {
        return useApiClient().post('bookkeepings/ksef/purchase-invoices/return-to-verification', {
            invoice_ids: invoiceIds,
            comment,
            item_comments: itemComments,
        });
    },
    archive(id: number) {
        return useApiClient().post(`bookkeepings/ksef/purchase-invoices/${id}/archive`);
    },
    unarchive(id: number) {
        return useApiClient().post(`bookkeepings/ksef/archived-purchase-invoices/${id}/unarchive`);
    },
    getPdf(id: number) {
        return useApiClient().get(`bookkeepings/ksef/purchase-invoices/${id}/pdf`);
    },
    getSourceXml(id: number) {
        return useApiClient().get(`bookkeepings/ksef/purchase-invoices/${id}/source-xml`);
    },
    importPurchases() {
        return useApiClient().post('bookkeepings/ksef/purchase-invoices/import');
    },
    getInvoice(id: number) {
        return useApiClient().get(`bookkeepings/ksef/purchase-invoices/${id}`);
    },
    acceptInvoiceItems(id: number, itemIds: number[]) {
        return useApiClient().post(`bookkeepings/ksef/purchase-invoices/${id}/accept-invoice-items`, {
            invoice_item_ids: itemIds,
        });
    },
    getItemCommentsCounts(id: number) {
        return useApiClient().get(`bookkeepings/ksef/purchase-invoices/${id}/item-comments-counts`);
    },
    getComments(id: number, itemId: number | null = null) {
        return useApiClient().get(`bookkeepings/ksef/purchase-invoices/${id}/comments`, {
            params: itemId === null ? undefined : { item_id: itemId },
        });
    },
    addComment(id: number, content: string, itemId: number | null = null) {
        return useApiClient().post(`bookkeepings/ksef/purchase-invoices/${id}/comments`, {
            content,
            ...(itemId === null ? {} : { item_id: itemId }),
        });
    },
};
